// Identifiants stables des sections de la sidebar GTB (UseCase.ENERGY).
// Declaration order = display order in the sidebar.
//
// ATTENTION : ces valeurs sont persistées en base (company_settings.sidebar_hidden_sections).
// Les traiter comme du contenu de base de données : ne jamais les renommer sans migration de
// données. Elles sont volontairement découplées des clés i18n, qui elles peuvent bouger.
export enum GtbSidebarSection {
  DASHBOARD = 'dashboard',
  ALARMS = 'alarms',
  DRIFT = 'drift',
  LOGBOOK = 'logbook',
  TEMPERATURE_BY_ZONE = 'temperatureByZone',
  BOILER_ROOM = 'boilerRoom',
  CTA = 'cta',
  VMC = 'vmc',
  HEAT_PUMP = 'heatPump',
  LIGHTING = 'lighting',
  ELECTRICAL_FAULTS = 'electricalFaults',
  MEDICAL_FLUIDS = 'medicalFluids',
  GENERAL = 'general',
}

// « Général » porte Informations / Équipements / Paramètres : la masquer enfermerait un client
// admin hors de /company/settings. Verrouillée dans l'écran admin ET refusée par l'API.
export const LOCKED_GTB_SIDEBAR_SECTIONS: ReadonlyArray<GtbSidebarSection> = [GtbSidebarSection.GENERAL]
